module.exports = __webpack_public_path__ + "static/media/mountain-runner.7f0a595b.jpg";